import { AuthenticationStrategy } from '../../api/discovery.api';

export const generateStrategyUrlForWorkspace = (workspaceId: string) => {
	return (strategy: AuthenticationStrategy) => {
		return `/${workspaceId}/login/strategy/${strategy}`;
	};
};
